export default "__VITE_ASSET__E41pjQhco8crdFKSeaw4IA__";